/** @jsx isolateComponent */

import { Button } from '@zapier/design-system';
import { isolateComponent } from '@zapier/style-encapsulation';

type Props = {
  onClick: () => void;
};

export const UpgradeButton = ({ onClick }: Props) => (
  <Button hasShadow={true} onClick={onClick}>
    Upgrade
  </Button>
);
